import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import red from "@material-ui/core/colors/red";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Slider from "react-slick";

const styles = theme => ({
  card: {
    width: 700
  },
  media: {
    height: 300,
    backgroundSize: "100% 100%"
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: "#edeg1e"
  }
});

class RecipeReviewCard extends React.Component {
  state = { expanded: false };
  downloadFile = item => {
    console.log("click", item);
    var docUrl = `http://localhost:5000${item.EFPath}`;
    // var filePath = `${GlobalValue.USER_INFO.SCDBName}/${item.EDDateTime.substr(
    //   0,
    //   10
    // )}${item.EDDateTime.substr(11, 8)}_${item.EDMilliSecond}_${
    //   item.EFAddSTCode
    // }${item.EFSeq + 1}`;
    // var url = docUrl + filePath + ext;

    // if (item.EFPath.includes("PDF")) {
    // window.open(`http://14.63.172.72/pdf?file=${docUrl}`);
    // } else {
    window.open(docUrl);
    // window.location.href = docUrl;
    // window.location.assign(docUrl);
    // }
  };
  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };
  // componentWillReceiveProps() {
  //   this.refs.slick.innerSlider.onWindowResized();
  // }
  render() {
    const { classes, noticeItem } = this.props;
    const images =
      noticeItem !== null
        ? noticeItem.files.filter(item => item.EFGubun === 0)
        : [];
    const refFiles =
      noticeItem !== null
        ? noticeItem.files.filter(item => item.EFGubun === 1)
        : [];
    console.log(refFiles);
    console.log("images", images);
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };
    console.log("this.props", this.props);
    return (
      <Card className={classes.card}>
        {noticeItem !== null && (
          <>
            <CardHeader
              avatar={
                <Avatar aria-label="Recipe" className={classes.avatar}>
                  관
                </Avatar>
              }
              // action={
              //   <IconButton>
              //     <MoreVertIcon />
              //   </IconButton>
              // }
              title={noticeItem.EDTITLE}
              subheader={noticeItem.EDDATETIME}
            />
            <div style={{ width: "100%", marginBottom: "30px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center"
                }}
              >
                <CardContent>
                  <Typography component="label">첨부파일</Typography>
                </CardContent>
                {refFiles.map((item, index) => (
                  <button key={index} onClick={() => this.downloadFile(item)}>
                    {item.EFPath.split("/")[3]}
                  </button>
                ))}
              </div>
              <Slider ref="slick" {...settings}>
                {images.length > 0 ? (
                  images.map((item, index) => {
                    return (
                      <CardMedia
                        className={classes.media}
                        image={`http://1.246.219.187:5000${item.EFPath}`}
                        key={index}
                      />
                    );
                  })
                ) : (
                  <CardMedia
                    className={classes.media}
                    image={null}
                    title="Paella dish"
                  />
                )}
              </Slider>
            </div>
            {/* <ul>
          {images.map((item, index) => {
            return (
              <li>
                <CardMedia
                  className={classes.media}
                  key={index}
                  image={item}
                  title="Paella dish"
                />
              </li>
            );
          })}
        </ul> */}
            <CardContent>
              <Typography component="p">{noticeItem.EDTEXT}</Typography>
            </CardContent>
            {/* <CardActions className={classes.actions} disableActionSpacing>
          <IconButton aria-label="Add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="Share">
            <ShareIcon />
          </IconButton>
          <IconButton
            className={classnames(classes.expand, {
              [classes.expandOpen]: this.state.expanded
            })}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions> */}
          </>
        )}
      </Card>
    );
  }
}

RecipeReviewCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RecipeReviewCard);
